import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router'

import * as ROUTES from 'config/routes'
// import OperatorEdit from './operator-edit'
import AgentList from './agent-list'
import AgentAdd from './agent-add'
import { PageContent } from 'components'
import { PageContainer } from 'smart-components'
import { userIsAuthenticatedRedir } from 'hocs/auth'

const Agent = () => (
    <PageContainer>
        <PageContent>
            <PageContent.Main>
                <Switch>
                    <Route
                        exact
                        path={ROUTES.AGENT}
                        component={AgentList}
                    />
                    {/* <Route
                        exact
                        path={ROUTES.OPERATOR_EDIT}
                        component={OperatorEdit}
                    /> */}
                    <Route
                        exact
                        path={ROUTES.AGENT_ADD}
                        component={AgentAdd}
                    />
                </Switch>
            </PageContent.Main>
        </PageContent>
    </PageContainer>
)

export default userIsAuthenticatedRedir(Agent)



// WEBPACK FOOTER //
// ./src/pages/agent/index.js